import { render, staticRenderFns } from "./InvestmentBlock.vue?vue&type=template&id=45ec9be2"
import script from "./InvestmentBlock.vue?vue&type=script&lang=js"
export * from "./InvestmentBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports